import * as React from 'react';
import * as LabelPrimitives from '@radix-ui/react-label'; // Using Radix for association
import { cva, type VariantProps } from 'class-variance-authority'; // For potential variants
import { cn } from '@/lib/utils'; // Assuming a utility for class merging exists

// Basic label styling for now
const labelVariants = cva(
  'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
);

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitives.Root> & VariantProps<typeof labelVariants> // Allow variants if added later
>(({ className, ...props }, ref) => (
  <LabelPrimitives.Root ref={ref} className={cn(labelVariants(), className)} {...props} />
));
Label.displayName = LabelPrimitives.Root.displayName;

export { Label };
